import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from 'components/button/Button';
import { Container } from './Info.styles';

const ErrorHeroInfo = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const redirectToHome = () => {
    navigate('/login');
  };

  return (
    <Container>
      <div>
        <h1>{t('pageNotFound.somethingIsWrong')}</h1>

        <Button bigRounded onClick={redirectToHome}>
          {t('pageNotFound.goBack')}
        </Button>
      </div>
    </Container>
  );
};

export default ErrorHeroInfo;
